$( document ).ready(function() {
	$(function() {

		function slider() {
			//var pathname = window.location.pathname; // Returns path only
			var currentUrl = window.location.href;     // Returns full URL
	    	var handle = $( "#custom-slider" );
	    	var maxPages = $( "#max-pages" ).text();
	    	var currentPage = $( "#slider" ).data("current-page");
	    	var hash = document.location.hash;

			function getParameterByName(name, url) {
			    if (!url) {
			      url = window.location.href;
			    }
			    name = name.replace(/[\[\]]/g, "\\$&");
			    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
			        results = regex.exec(url);
			    if (!results) return null;
			    if (!results[2]) return '';
			    return decodeURIComponent(results[2].replace(/\+/g, " "));
			}

			// query string: ?tab=framework
			var urlCurrentPage = getParameterByName('currentpage'); // "currentpage"
			var urlTopics = getParameterByName('topics'); // "topics"
			var urlQuery = window.location.search;

		    $( "#slider" ).slider({
		      min: 1,
		      max: maxPages,
		      value: currentPage,
		      create: function() {
		        handle.text( $( this ).slider( "value" ) );
		      },
		      slide: function( event, ui ) {
		        handle.text( ui.value );
		      }
		    });

		    $( "#slider" ).on( "slidestop", function( event, ui ) {
		    	var sliderValue = $( this ).slider( "value" );
		    	var newsUrl;
		    	// console.log("slider value ", sliderValue);
		    	// console.log( "urlCurrentPage = ",urlCurrentPage, "urlTopics = ", urlTopics);
		    	if(urlQuery) {
		    		if(urlCurrentPage != null) {
			    		newsUrl = location.href.replace("currentpage="+urlCurrentPage, "currentpage="+sliderValue);
			    	} else {
			    		newsUrl = currentUrl + "&" + "currentpage="+sliderValue;
			    	}
		    	} else {
		    		newsUrl = currentUrl + "?" + "currentpage="+sliderValue;
		    	}
		    	
		    	// console.log("newsUrl ", newsUrl, "urlQuery ", urlQuery);
		    	window.location.href = newsUrl;
		    } );

	    }
	    if($("#slider").length > 0) {
	    	slider(); 
	    }



	    function applyFilters() {


            var selectedFilter = [];
	    	var applyBtn = $( ".apply-filters" );
		    applyBtn.on('click',function(event) {

		    	selectedFilter = [];

                $('.custom-checkbox input:checked').each(function(event){
	                // console.log("query ", $(this).data("query"));
                    selectedFilter.push($(this).data("query"));
	            });

                // console.log("selectedFilter= ",selectedFilter.join("&"));
                newsUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?"+ selectedFilter.join("&");
                window.location.href = newsUrl;
                
            });


            $('.custom-checkbox input[checked="true"]').each(function(event){
	                console.log("query ", $(this).data("query"));
                    this.checked;
	        });


            // Type ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
            $('.custom-checkbox input').change(function(event){
                // console.log("change", $(this).val());
                if (this.checked ) {
                    !this.checked;
                    // console.log("this was not checked ", this);
                } else {
                	// console.log("this was ", this);
                    this.checked;
                    // removeItem = $(this).val();
                    // selectedFilter.splice( $.inArray(removeItem, selectedFilter), 1 );
                }
            });

	    }
	    if($(".apply-filters").length > 0) {
	    	applyFilters(); 
	    }


	});
});



// WEBPACK FOOTER //
// ./js/slider.js